import { useQuery } from 'urql';
import { graphql } from '@/gql/graphql';

const GetSupportConfiguration = graphql(`
  query GetSupportConfiguration {
    configuration_by_pk(kind: support_person_id) {
      value
    }
  }
`);

export default function useSupportPersonId() {
  const [{ data }] = useQuery({ query: GetSupportConfiguration });
  return data?.configuration_by_pk?.value;
}
